import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=b5a1dcee&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"
import style0 from "./Asset.vue?vue&type=style&index=0&id=b5a1dcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a1dcee",
  null
  
)

export default component.exports